export default __webpack_public_path__ + "static/media/bakerHealth-stack3.webp";